module.exports = __webpack_public_path__ + "img/backgroundImage.e0dc140a.jpg";